import React from "react";
import { Col, Modal, Row } from "react-bootstrap";

import Form from "~/components/form";
import SubmitButton from "~/components/form/submit";
import IconButton from "~/components/icon-button";
import { axios } from "~/utils";

import CountryTierView from "../country-tier/view";
import Schema from "./validation-schema";

function NetworkEditModal({ data, unitId, onEdit }) {
  const { countryTier, network, id, ...initial } = data;

  const [show, setShow] = React.useState(false);

  const closeModal = () => setShow(false);
  const showModal = () => setShow(true);
  return (
    <>
      <IconButton.Edit size="sm" onClick={showModal} />
      <Modal show={show} onHide={closeModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Edit setting for network{" "}
            <i>
              {network || "all"} (<CountryTierView value={countryTier} />)
            </i>
          </Modal.Title>
        </Modal.Header>
        <Form
          form={false}
          initialValues={initial}
          validationSchema={Schema}
          onSubmit={(values) =>
            axios({
              method: "PUT",
              url: `api/ad-units/${unitId}/network-params/${id}`,
              data: values,
            }).then(() => {
              onEdit();
              closeModal();
            })
          }
        >
          <Modal.Body className="px-5">
            <Form.InnerForm>
              <Form.Group as={Row} className="mb-3" controlId="network-enabled">
                <Form.Label column sm={4}>
                  Enabled
                </Form.Label>
                <Col sm={8}>
                  <Form.Check name="enabled" />
                  <Form.Control.ErrorFeedback name="enabled" />
                </Col>
              </Form.Group>

              <Form.Group
                as={Row}
                className="mb-3"
                controlId="network-active-minimum"
              >
                <Form.Label column sm={4}>
                  Active minimum
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="number" name="activeMinimum" />
                  <Form.Control.ErrorFeedback name="activeMinimum" />
                </Col>
              </Form.Group>

              <Form.Group
                as={Row}
                className="mb-3"
                controlId="network-active-maximum"
              >
                <Form.Label column sm={4}>
                  Active maximum
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="number" name="activeMaximum" />
                  <Form.Control.ErrorFeedback name="activeMaximum" />
                </Col>
              </Form.Group>

              <Form.Group
                as={Row}
                className="mb-3"
                controlId="network-lowest-placement-active"
              >
                <Form.Label column sm={4}>
                  Lowest Placement Active
                </Form.Label>
                <Col sm={8}>
                  <Form.Check name="lowestPlacementActive" />
                  <Form.Control.ErrorFeedback name="lowestPlacementActive" />
                </Col>
              </Form.Group>

              <Form.Group
                as={Row}
                className="mb-3"
                controlId="network-launch-all-placements"
              >
                <Form.Label column sm={4}>
                  Launch All Placements
                </Form.Label>
                <Col sm={8}>
                  <Form.Check name="launchAllPlacements" />
                  <Form.Control.ErrorFeedback name="launchAllPlacements" />
                </Col>
              </Form.Group>

              {/* this input is needed to allow to submit form by pressing enter */}
              <input type="submit" className="d-none" />
            </Form.InnerForm>
          </Modal.Body>
          <Modal.Footer>
            <SubmitButton />
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default NetworkEditModal;
